import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { LegalBody } from "./Privacy";

const SECTIONS = [
  ["About these terms", ["These terms apply to services provided by Easy Handyman Services to customers in Oxfordshire. By accepting a quotation, you agree to these terms. [Business owner: please review these terms and adjust them to match how you work.]"]],
  ["Quotations", ["Quotations are free and without obligation. A quotation is based on the information and photos you provide and on our assessment of the job. If the work required turns out to be different, we will discuss any change with you before going ahead."]],
  ["Appointments", ["We will agree a date and time with you. If you need to rearrange, please let us know as early as possible. A preferred date given on the quote form is a request and is confirmed only once we agree it with you."]],
  ["Access and preparation", ["Please make sure we can access the areas where work will be carried out, and let us know about anything we should be aware of, such as pets, parking or fragile items."]],
  ["Payment", ["Payment terms will be set out in your quotation. [Business owner: add your payment terms here.]"]],
  ["Concerns", ["If you're not happy with any part of our work, please tell us as soon as possible so we can put it right. Nothing in these terms affects your statutory rights as a consumer."]],
  ["Contact", ["Easy Handyman Services · 07836 207134 · easyhandymanservicesuk@gmail.com · Oxfordshire, UK."]],
];

export default function Terms() {
  return (
    <>
      <Seo title="Terms and Conditions | Easy Handyman Services" description="Terms and conditions for quotations and property maintenance services provided by Easy Handyman Services in Oxfordshire." />
      <PageHero testId="terms-hero" eyebrow="Legal" lines={["Terms and Conditions"]} />
      <LegalBody sections={SECTIONS} updated="3 November 2026" />
    </>
  );
}
